import { IRootReducerState } from "../../../redux-store/rootReducer";
import { IAuditLogPayload, AuditAction } from "../../../types/audit";
import { resolveActor } from "../utils/resolveActor";
import { AnyAction } from "redux";
import { stripAuditPayloadKeys } from "../utils/stripAuditPayloadKeys";
import { getChangedFields } from "../utils";
import { v4 as uuidv4 } from "uuid";

export const buildMenuModifierEntries = (
  action: AnyAction,
  state: IRootReducerState
): IAuditLogPayload[] => {
  const payload = action.payload as any;
  const prevModifierGroup = payload?.__prevModifierGroup;
  const cleanPayload =
    payload && typeof payload === "object" ? stripAuditPayloadKeys(payload) : payload;
  const { actor, actor_type, accountManager, store } = resolveActor(state);

  const actionType = action.type.toLowerCase();
  let auditAction: AuditAction;
  if (actionType.includes("create")) auditAction = "CREATE";
  else if (actionType.includes("delete")) auditAction = "DELETE";
  else auditAction = "UPDATE";

  const rawId = cleanPayload?.id ?? prevModifierGroup?.id;
  const entityId = rawId != null ? String(rawId) : uuidv4();
  const entityName =
    cleanPayload?.en_name ||
    cleanPayload?.ar_name ||
    prevModifierGroup?.en_name ||
    prevModifierGroup?.ar_name ||
    "";

  const fullBefore =
    auditAction !== "UPDATE" ? ({} as Record<string, unknown>) : prevModifierGroup || ({} as Record<string, unknown>);
  const fullAfter =
    auditAction !== "UPDATE"
      ? ({} as Record<string, unknown>)
      : cleanPayload && typeof cleanPayload === "object"
        ? ({ ...cleanPayload } as Record<string, unknown>)
        : ({} as Record<string, unknown>);

  const { before: beforeState, after: afterState } =
    auditAction === "UPDATE"
      ? getChangedFields(fullBefore, fullAfter)
      : { before: fullBefore, after: fullAfter };

  return [
    {
      service_name: "order",
      action: auditAction,
      actor,
      actor_type,
      service_type: "ordering_menu",
      entity_type: "modifier",
      entity_id: entityId,
      entity_name: entityName,
      change_area: "modifier",
      before_state: beforeState,
      after_state: afterState,
      metadata: {
        account_manager: accountManager,
        parent_type: "store",
        parent_id: store.id,
        parent_name: store.name,
        parent_image: store.image,
      },
    },
  ];
};
